var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdWasteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.418 19.3681C35.1481 18.6697 33.0529 19.1934 30.0847 20.0664C29.2116 20.241 28.3386 20.765 27.4656 21.4634C26.9417 21.9872 26.418 22.3363 26.418 22.6855C26.418 24.0823 29.5608 25.6536 33.9259 25.479C36.8942 25.479 41.0847 24.4317 41.2593 22.8603C41.6085 21.2889 39.1641 19.8919 37.418 19.3681Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158203 33.9577C1.03122 82.6722 72.2697 83.7196 69.1268 36.7511C72.7935 -8.99511 7.14237 -11.9632 0.158203 33.9577ZM45.0314 25.9259C45.0314 25.9259 45.7299 54.2114 42.0632 54.0368C21.6345 54.9098 26.6981 60.1481 24.4282 26.6242C10.4598 17.3701 45.5553 11.608 47.3013 22.6081C47.3013 23.6557 46.4282 24.8783 45.0314 25.9259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdWasteIcon);
export default __webpack_public_path__ + "static/media/prod-waste-icon.b80decc2afc523ff3749db7710753018.svg";
export { ForwardRef as ReactComponent };